/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React, { useEffect, useState, useMemo, Fragment } from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import { useMutation, useSubscription } from "@apollo/client";
import { Collapse, List, ListItemText, ListItem } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import { useCurrentUserUIContext } from "../../../../../app/Components/CurrentUser/CurrentUserContext";
import { DarkLightMode } from "../../../../../app/Components/DarkLightMode";
import { OrganizationModal } from "../../../../../app/Components/JoinOrganization";
import { usePermissionRoleUIContext } from "../../../../../app/Components/PermissionRole";
import { StatusPopper } from "../../../../../app/Components/Popper/StatusPopper";
import { SectionLoader } from "../../../../../app/Components/SectionLoader";
import { SET_CURRENT_ORGANIZATION } from "../../../../../app/GraphQlCommon/mutation";
import { USER_NOTIFICATION } from "../../../../../app/GraphQlCommon/query";
import * as auth from "../../../../../app/Modules/Auth/_redux/authRedux";
import {
  ROLE_BUYER,
  ROLE_C_ADMIN,
  ROLE_GUEST,
  ROLE_SELLER,
  ROLE_ASSET_MANAGER,
  ROLE_SUPER_ADMIN,
  ROLE_INDIVIDUAL,
  ROLE_CONSULTANT,
  LOCAL_STORAGE_ROLES
} from "../../../../../app/Utils/constant";
import { LOGOUT } from "../../../../../app/Utils/routePaths";
import { setShowOrgModal } from "../../../../../redux/layout/layoutActions";
import { toAbsoluteUrl } from "../../../../_helpers";

export function QuickUser() {
  const history = useHistory();

  const [roleName, setRoleName] = useState(null);

  const [currentuser, setCurrentUser] = useState(null);

  const [isOrgActionClick, setIsOrgActionClick] = useState(false);

  const [showOrganizationList, setShowOrganizationList] = useState(false);

  const toggleSwitchOrganization = () =>
    setShowOrganizationList(value => !value);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const { showOrgModal } = useSelector(
    state => ({ showOrgModal: state.layout.showOrgModal }),
    shallowEqual
  );

  const [
    setCurrentOrganization,
    {
      data: setCurrentorganization,
      loading: setCurrentorganizationLoading,
      error: setCurrentorganizationError
    }
  ] = useMutation(SET_CURRENT_ORGANIZATION);

  const currentUserContext = useCurrentUserUIContext();

  const {
    setPermissionRoles,
    rolePermissionData
  } = usePermissionRoleUIContext();

  const currentUserUIProps = useMemo(() => {
    return {
      currentUser: currentUserContext.currentUser,
      setCurrentUser: currentUserContext.setCurrentUser,
      currentUserError: currentUserContext.currentUserError
    };
  }, [currentUserContext]);

  useEffect(() => {
    if (currentUserUIProps.currentUser) {
      const data = currentUserUIProps.currentUser?.me;

      let tempData = { ...data };
      setCurrentUser(data);
      if (data.userOrg && data.userOrg.length > 0) {
        var tempObj = data.userOrg.find(element => {
          if (element.organization?.id === data.currentOrganization?.id) {
            if (
              element.roles &&
              element.roles[0]?.key === ROLE_GUEST &&
              element.isIndividual
            )
              return null;
            else return element;
          }
        });

        if (tempObj) {
          const user = JSON.parse(window.localStorage.getItem("user"));

          if (user) {
            user.isUserVerified = tempObj.isVerified;
            user.isIndividual = tempObj.isIndividual;
            user.isInvited = tempObj.isInvited;
            user.isOnline = tempObj.isOnline;
            user.isInvitedAndMerge = tempObj.isInvitedAndMerge;
            user.currentOrganization = data.currentOrganization;
            user.userOrg = data.userOrg;
            user.isEmailVarified = data.isEmailVarified;
            window.localStorage.setItem("user", JSON.stringify(user));
            dispatch(
              auth.actions.fulfillUser({
                ...user
              })
            );
          }

          const roles = tempObj?.roles.map(role => role.key);

          if (roles && roles.length > 0) {
            window.localStorage.setItem(
              LOCAL_STORAGE_ROLES,
              JSON.stringify(roles)
            );
          } else {
            const roles = data?.roles.map(role => role.key);

            window.localStorage.setItem(
              LOCAL_STORAGE_ROLES,
              JSON.stringify(roles)
            );
          }

          setPermissionRoles();
        } else if (
          data?.roles?.findIndex(val => val?.key === ROLE_GUEST) > -1
        ) {
          tempData.isIndividual = true;
          tempData.isOnline = data.isOnline;
          window.localStorage.setItem("user", JSON.stringify(tempData));
          dispatch(
            auth.actions.fulfillUser({
              ...tempData
            })
          );
          const role = tempData?.roles.map(role => role.key);

          window.localStorage.setItem(
            LOCAL_STORAGE_ROLES,
            JSON.stringify(role)
          );
        }
      } else {
        window.localStorage.setItem("user", JSON.stringify(data));
        dispatch(
          auth.actions.fulfillUser({
            ...data
          })
        );
        const role = data?.roles.map(role => role.key);

        window.localStorage.setItem(LOCAL_STORAGE_ROLES, JSON.stringify(role));
      }
    }

    if (currentUserUIProps.currentUserError) {
      logoutClick();
    }
  }, [currentUserUIProps]);

  useEffect(() => {
    if (setCurrentorganizationError) {
      toast.error(setCurrentorganizationError?.message.toString(), {
        position: toast.POSITION.TOP_RIGHT
      });
    }

    if (setCurrentorganization) {
      toast.success("Organisation set successfully", {
        position: toast.POSITION.TOP_RIGHT
      });
      currentUserUIProps.setCurrentUser();
    }
  }, [
    setCurrentorganization,
    setCurrentorganizationLoading,
    setCurrentorganizationError
  ]);
  useEffect(() => {
    currentUserUIProps.setCurrentUser();
  }, [window.location.pathname]);

  const logoutClick = () => {
    const toggle = document.getElementById("kt_quick_user_toggle");

    if (toggle) {
      toggle.click();
    }

    history.push(LOGOUT);
  };

  const dispatch = useDispatch();

  const user = useSelector(state => state.auth.user, shallowEqual);

  const handleToggle = () => {
    dispatch(action.actions.darkLightMode());
  };

  useEffect(() => {
    if (user.pic) {
      setPic(user.pic);
    }

    const roles = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_ROLES));

    if (roles && roles.length > 0) {
      let tempStatus;
      roles.map(role => {
        if (role === ROLE_SUPER_ADMIN || ROLE_C_ADMIN) tempStatus = true;
      });
      if (tempStatus) setRoleName(roles[0]);
    }
  }, [user]);

  useEffect(() => {
    const roles = currentuser && currentuser.roles;

    if (roles && roles.length > 0) {
      let tempStatus = false;
      roles.map(role => {
        if (
          role.key === ROLE_BUYER ||
          role.key === ROLE_C_ADMIN ||
          role.key === ROLE_SELLER ||
          role.key === ROLE_GUEST
        )
          tempStatus = true;
      });
      if (tempStatus) setShowOrganizationList(true);
      else setShowOrganizationList(false);
    }
  }, [currentuser]);

  const notifyMe = msg => {
    // msg
  };

  useSubscription(USER_NOTIFICATION, {
    variables: {
      recievedId: user.id
    },
    fetchPolicy: "no-cache",
    onSubscriptionData(d) {
      notifyMe(d.subscriptionData.data.assetNotification.message);
    }
  });
  const renderNameAndRole = item => {
    if (item) {
      if (item.roles.findIndex(val => val?.key === ROLE_C_ADMIN) > -1)
        return `${item.organization.name} (Company Admin)`;
      if (item.roles.findIndex(val => val?.key === ROLE_BUYER) > -1)
        return `${item.organization.name} (${ROLE_BUYER})`;
      if (item.roles.findIndex(val => val?.key === ROLE_SELLER) > -1)
        return `${item.organization.name} (${ROLE_SELLER})`;
      if (item.roles.findIndex(val => val?.key === ROLE_GUEST) > -1)
        return `${item.organization.name} (${ROLE_GUEST})`;
      if (item.isIndividual)
        return `${item.organization.name} (${ROLE_INDIVIDUAL})`;
      if (item.roles.findIndex(val => val?.key === ROLE_CONSULTANT) > -1)
        return `${item.organization.name} (${ROLE_CONSULTANT})`;
    }
  };

  return (
    <div id="kt_quick_user" className="offcanvas offcanvas-right offcanvas p-5">
      <SectionLoader loader={setCurrentorganizationLoading} />
      <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
        <h3 className="font-weight-bold m-0">
          {" "}
          <FormattedMessage id="USER.PROFILE" />
        </h3>
        <a
          href="#"
          className="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i className="ki ki-close icon-xs text-muted" />
        </a>
      </div>

      <div className="offcanvas-content pr-5 mr-n5">
        <div className="d-flex align-items-start mt-5">
          <div className="symbol symbol-70 mr-5">
            {!user.profile_pic ? (
              <div
                className="symbol-label"
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(
                    "/media/users/blank.png"
                  )})`
                }}
              />
            ) : (
              <div
                className="symbol-label"
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(user.profile_pic)})`
                }}
              />
            )}

            {user?.roles.findIndex(val => val?.key === ROLE_ASSET_MANAGER) >
            -1 ? (
              <i
                className={`${
                  user?.isOnline
                    ? "symbol-badge bg-success"
                    : "symbol-badge badge-offline"
                }`}
              />
            ) : (
              <i className="symbol-badge bg-success" />
            )}
          </div>
          <div className="d-flex flex-column flex-fill">
            <a
              href="#"
              className="font-weight-bold font-size-h6 text-dark-75 text-hover-primary"
            >
              {user.displayName}
            </a>
            {currentuser &&
              currentuser.currentOrganization &&
              currentuser.currentOrganization.name && (
                <div className="text-muted">
                  {currentuser.currentOrganization.name}
                </div>
              )}

            <div className="navi">
              <a href="#" className="navi-item">
                <span className="navi-link p-0">
                  <span className="navi-icon">
                    <span className="svg-icon-lg svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Mail-notification.svg"
                        )}
                      ></SVG>
                    </span>
                  </span>
                  <span className="navi-text text-muted text-hover-primary">
                    {user.email ? user.email : "N/A"}
                  </span>
                </span>
              </a>
            </div>
            {user?.roles.findIndex(val => val?.key === ROLE_ASSET_MANAGER) >
              -1 && (
              <div>
                <StatusPopper
                  anchorEl={anchorEl}
                  setAnchorEl={setAnchorEl}
                  currentUserUIProps={currentUserUIProps}
                />
              </div>
            )}
            <button
              className="btn btn-primary btn-bold mt-3"
              onClick={logoutClick}
            >
              <FormattedMessage id="USER.SIGN_OUT" />
            </button>
          </div>
        </div>

        <div className="separator separator-dashed mt-3 mb-2" />

        <div className="navi navi-spacer-x-0 p-0">
          <a href="/admin/user-profile" className="navi-item">
            <div className="navi-link">
              <div className="symbol symbol-40 bg-light mr-3">
                <div className="symbol-label">
                  <span className="svg-icon svg-icon-md svg-icon-success">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/General/Notification2.svg"
                      )}
                    ></SVG>
                  </span>
                </div>
              </div>
              <div className="navi-text">
                <div className="font-weight-bold">
                  {" "}
                  <FormattedMessage id="USER.MY_PROFILE" />
                </div>
                <div className="text-muted">
                  <FormattedMessage id="USER.ACCOUNT_SETTING" />{" "}
                  <span className="label label-light-primary label-inline font-weight-bold">
                    <FormattedMessage id="USER.PROFILE_UPDATE" />
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>
        {currentuser &&
          currentuser.roles.findIndex(
            index => index?.key === ROLE_ASSET_MANAGER
          ) === -1 &&
          currentuser.roles.findIndex(
            index => index?.key === ROLE_SUPER_ADMIN
          ) === -1 &&
          (currentuser?.roles?.findIndex(val => val?.key === ROLE_GUEST) > -1 &&
          currentuser?.isUserVerified ? null : (
            <>
              <div className="separator separator-dashed mt-3 mb-2" />
              <div className="navi navi-spacer-x-0 p-0">
                <a className="navi-item">
                  {currentuser && currentuser?.userOrg.length > 0 ? (
                    <ListItem
                      style={{ background: "white" }}
                      button
                      onClick={toggleSwitchOrganization}
                    >
                      <ListItemText
                        primary={<FormattedMessage id="SWITCH_ORGANIZATION" />}
                      />
                      {showOrganizationList ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                  ) : (
                    <ListItem
                      style={{ background: "white" }}
                      button
                      onClick={() => {
                        dispatch(setShowOrgModal(true));
                      }}
                    >
                      <ListItemText
                        primary={
                          <FormattedMessage id="ADD_OR_JOIN_ORGANISATION" />
                        }
                      />
                    </ListItem>
                  )}

                  <Collapse
                    in={showOrganizationList}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <div>
                        {currentuser &&
                          currentuser.userOrg &&
                          currentuser.userOrg.map((item, index) => {
                            return (
                              !item.isDeleted &&
                              (currentuser.userOrg.length > 1 &&
                              item.isIndividual &&
                              item?.roles?.findIndex(
                                val => val?.key === ROLE_GUEST
                              ) > -1 ? null : (
                                <Fragment key={`user-org-${index}`}>
                                  <ListItem
                                    key={index}
                                    style={{
                                      background:
                                        currentuser?.currentOrganization.id ===
                                        item.organization.id
                                          ? "#fcb134"
                                          : "#ffffff"
                                    }}
                                    button
                                    onClick={() => {
                                      if (currentuser.userOrg.length > 1) {
                                        setCurrentOrganization({
                                          variables: {
                                            orgId: item.organization?.id
                                          }
                                        });
                                      }
                                    }}
                                  >
                                    <div className="navi navi-spacer-x-0 p-0">
                                      <a className="navi-item">
                                        <div className="navi-link">
                                          <div className="topbar-item">
                                            <div
                                              className="w-auto d-flex align-items-center"
                                              id="kt_quick_user_toggle"
                                            >
                                              <>
                                                <span className="symbol symbol-25 mr-3">
                                                  <span className="symbol-label font-size-h5 font-weight-bold">
                                                    {item?.organization &&
                                                    item.organization?.name
                                                      ? item.organization
                                                          ?.name[0]
                                                      : "N"}
                                                  </span>
                                                </span>
                                              </>
                                            </div>
                                          </div>
                                          <div className="navi-text d-flex justify-content-between align-items-center">
                                            <div
                                              className={`${
                                                item.isVerified
                                                  ? "approved"
                                                  : "dApproved"
                                              }`}
                                            >
                                              {item.organization &&
                                              item.organization.name
                                                ? renderNameAndRole(item)
                                                : "No name found"}
                                            </div>
                                            {!item.isVerified && (
                                              <span className="badge badge-danger">
                                                <FormattedMessage id="EMAIL.NOT_VERIFIED" />
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </ListItem>
                                </Fragment>
                              ))
                            );
                          })}
                        <ListItem style={{ background: "white" }} button>
                          <div
                            className="navi navi-spacer-x-0 p-0"
                            style={{ background: "#ffffff" }}
                          >
                            <a className="navi-item">
                              <div className="navi-link">
                                <div className="symbol symbol-25 bg-light mr-3">
                                  <div className="symbol-label">
                                    <span className="svg-icon svg-icon-md svg-icon-success">
                                      <Add />
                                    </span>
                                  </div>
                                </div>
                                <div className="navi-text">
                                  <div
                                    className=""
                                    onClick={() => {
                                      dispatch(setShowOrgModal(true));
                                    }}
                                  >
                                    <FormattedMessage id="ADD_OR_JOIN_ORGANISATION" />
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                        </ListItem>
                      </div>
                    </List>
                  </Collapse>
                </a>
              </div>
            </>
          ))}

        <div className="separator separator-dashed my-2"></div>

        <DarkLightMode handleToggle={handleToggle} />
      </div>

      {showOrgModal && <OrganizationModal />}
    </div>
  );
}
